import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { useAssessment } from '../../hooks/useAssessment';
import { Clock, User, Activity, ArrowLeft } from 'lucide-react';
export function AuditTrail() {
  const navigate = useNavigate();
  const {
    assessment
  } = useAssessment();
  return <div className="max-w-4xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-219">
      <div className="mb-8" data-id="element-220">
        <Button variant="ghost" onClick={() => navigate('/assessment/analysis')} className="mb-4 -ml-2" data-id="element-221">
          <ArrowLeft className="h-4 w-4 mr-2" data-id="element-222" />
          Back to Analysis
        </Button>

        <h1 className="text-3xl font-bold mb-3" data-id="element-223">Audit Trail</h1>
        <p className="text-slate-400 text-lg" data-id="element-224">
          Immutable record of all assessment activities, evidence uploads, and
          classifications.
        </p>
      </div>

      {assessment.auditTrail && assessment.auditTrail.length > 0 ? <div className="relative border-l border-slate-800 ml-4 space-y-8" data-id="element-225">
          {assessment.auditTrail.map(event => <div key={event.id} className="relative pl-8" data-id="element-226">
              {/* Timeline Dot */}
              <div className="absolute -left-1.5 top-1.5 h-3 w-3 rounded-full border-2 border-navy-900 bg-teal-500" data-id="element-227" />

              <Card className="p-5 hover:border-slate-600 transition-colors" data-id="element-228">
                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-229">
                  <div className="flex-1" data-id="element-230">
                    <h3 className="text-lg font-medium text-white mb-1" data-id="element-231">
                      {event.action}
                    </h3>
                    {event.details && <p className="text-slate-400 mb-3" data-id="element-232">{event.details}</p>}

                    <div className="flex items-center space-x-4 text-xs text-slate-500 font-mono uppercase tracking-wide" data-id="element-233">
                      <div className="flex items-center" data-id="element-234">
                        <User className="h-3 w-3 mr-1.5" data-id="element-235" />
                        {event.user}
                      </div>
                      <div className="flex items-center" data-id="element-236">
                        <Activity className="h-3 w-3 mr-1.5" data-id="element-237" />
                        ID: {event.id.slice(0, 8)}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center text-sm text-slate-500 whitespace-nowrap bg-navy-900 px-3 py-1 rounded border border-slate-800" data-id="element-238">
                    <Clock className="h-3 w-3 mr-2" data-id="element-239" />
                    {new Date(event.timestamp).toLocaleString()}
                  </div>
                </div>
              </Card>
            </div>)}
        </div> : <Card className="text-center py-12 border-dashed" data-id="element-240">
          <Activity className="h-12 w-12 text-slate-600 mx-auto mb-4" data-id="element-241" />
          <h3 className="text-lg font-medium text-slate-300 mb-2" data-id="element-242">
            No activity recorded yet
          </h3>
          <p className="text-slate-500 mb-6" data-id="element-243">
            Complete assessment steps to build your audit trail.
          </p>
          <Button onClick={() => navigate('/assessment/regulation')} data-id="element-244">
            Start Assessment
          </Button>
        </Card>}
    </div>;
}